<template>
  <div class="page-root">
    <div class="settings-content">
      <h1>
        <span class="font-weight-bold"> {{ $t("settings.title") }} </span>
      </h1>

      <v-tabs v-model="tab" class="mt-2" color="primary lighten-1">
        <v-tab>{{ $t("settings.tabAccount") }}</v-tab>
        <v-tab>{{ $t("settings.tabBroadcast") }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <!-- 계정설정 -->
        <v-tab-item>
          <div class="app-page__content mt-4 pa-4" style="max-width: 480px">
            <!-- 프로필 사진 -->
            <h5 class="mb-2">{{ $t("settings.profile") }}</h5>
            <div class="d-flex align-center">
              <v-avatar size="56" class="mr-3">
                <v-img :src="$store.state.userImageUrl" alt="profile" />
              </v-avatar>
              <v-btn color="primary" small outlined @click="openProfileDialog">
                {{ $t("settings.profileEdit") }}
              </v-btn>
            </div>
            <!-- 현재 로그인 계정 이메일 -->
            <p v-if="accountEmail" class="text-caption grey--text mt-2 mb-0">{{ accountEmail }}</p>

            <v-divider class="my-6"></v-divider>

            <!-- 닉네임 -->
            <h5 class="mb-2">{{ $t("settings.nickname") }}</h5>
            <v-text-field
              v-model="nickname"
              outlined
              dense
              hide-details="auto"
              :placeholder="$t('settings.nickname')"
            ></v-text-field>
            <div class="d-flex justify-end mt-2">
              <v-btn color="primary" small :loading="isSavingNickname" :disabled="!nickname" @click="onSaveNickname">
                {{ $t("common.save") }}
              </v-btn>
            </div>

            <v-divider class="my-6"></v-divider>

            <!-- 비밀번호 변경 -->
            <h5 class="mb-2">{{ $t("settings.passwordChange") }}</h5>
            <v-text-field
              v-model="newPassword"
              type="password"
              outlined
              dense
              hide-details="auto"
              :placeholder="$t('settings.newPassword')"
              class="mb-2"
            ></v-text-field>
            <v-text-field
              v-model="confirmPassword"
              type="password"
              outlined
              dense
              hide-details="auto"
              :placeholder="$t('settings.confirmPassword')"
            ></v-text-field>
            <div class="d-flex justify-end mt-2">
              <v-btn
                color="primary"
                small
                :loading="isSavingPassword"
                :disabled="!newPassword || !confirmPassword"
                @click="onSavePassword"
              >
                {{ $t("settings.change") }}
              </v-btn>
            </div>
          </div>

          <!-- 프로필 사진 변경 다이얼로그 -->
          <base-dialog
            v-model="isShowProfileDialog"
            :title="$t('settings.profileEdit')"
            :max-width="420"
            persistent
          >
            <!-- 업로드 탭에서 크롭 중이면 상단 미리보기 숨김(크롭퍼가 미리보기 역할) -->
            <div v-if="!(profileTab === 1 && profileFilePreview)" class="d-flex justify-center pb-2">
              <v-avatar size="88">
                <v-img :src="profilePreviewUrl" alt="preview" />
              </v-avatar>
            </div>

            <v-tabs v-model="profileTab" grow color="primary lighten-1" class="mb-3">
              <v-tab>{{ $t("settings.profileTabUrl") }}</v-tab>
              <v-tab>{{ $t("settings.profileTabUpload") }}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="profileTab">
              <!-- URL 입력 (외부 이미지) -->
              <v-tab-item>
                <v-text-field
                  v-model="profileImageUrl"
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="https://..."
                  :hint="$t('settings.profileUrlHint')"
                  persistent-hint
                ></v-text-field>
              </v-tab-item>

              <!-- 업로드 (원형 크롭 후 R2 업로드) -->
              <v-tab-item>
                <v-file-input
                  v-model="profileFile"
                  accept="image/*"
                  outlined
                  dense
                  prepend-icon="mdi-camera"
                  hide-details="auto"
                  :label="$t('settings.profileTabUpload')"
                ></v-file-input>
                <template v-if="profileFilePreview">
                  <image-circle-cropper ref="profileCropper" :src="profileFilePreview" class="mt-4" />
                  <p class="text-caption grey--text text-center mt-2 mb-0">{{ $t("settings.cropHint") }}</p>
                </template>
                <p v-else class="text-caption grey--text mt-2 mb-0">{{ $t("settings.profileUploadHint") }}</p>
              </v-tab-item>
            </v-tabs-items>

            <template #actions>
              <v-btn text @click="isShowProfileDialog = false">{{ $t("common.cancel") }}</v-btn>
              <v-btn color="primary" :loading="isSavingProfile" :disabled="!canSaveProfile" @click="onSaveProfileImage">
                {{ $t("common.save") }}
              </v-btn>
            </template>
          </base-dialog>
        </v-tab-item>

        <!-- 방송설정 (방송화면 위치/크기 + 버츄펫 변경) -->
        <v-tab-item eager>
          <div class="app-page__content mt-4 pa-4">
            <!-- 프로필 -->
            <div>
              <!-- <h5>버츄펫 변경</h5> -->
              <!-- 버츄펫 변경 막아둠 버전 v5 modelIndex bear -> bear_v5 가야됨 (activator 비활성) -->
              <v-dialog v-model="isShowDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                  <v-toolbar dark color="primary">
                    <v-btn icon dark @click="isShowDialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>버츄펫 변경하기</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                      <v-btn dark text @click="isShowDialog = false"> 저장하기 </v-btn>
                    </v-toolbar-items>
                  </v-toolbar>
                  <!-- duplicate code -->
                  <div class="mt-6">
                    <div class="d-flex flex-wrap justify-center">
                      <div v-for="(meta, i) in modelMetas" :key="i">
                        <div class="model-card__wrapper px-2 py-1" @click="onSelectModel(meta.modelIndex)">
                          <PreviewModelCard
                            :index="i"
                            :modelIndex="meta.modelIndex"
                            :isTrial="meta.isAvailable"
                            :selected="selectedModelIndex === meta.modelIndex"
                          ></PreviewModelCard>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-dialog>
            </div>
            <div class="mt-4">
              <h5>{{ $t("settings.screenPosition") }}</h5>
              <div class="ml-2 mt-1">
                <div class="parent">
                  <div class="child" id="top-left" @click="onClickCell"></div>
                  <div class="child" id="top-center" @click="onClickCell"></div>
                  <div class="child" id="top-right" @click="onClickCell"></div>

                  <div class="child" id="center-left" @click="onClickCell"></div>
                  <div class="child" id="center-center" @click="onClickCell"></div>
                  <div class="child" id="center-right" @click="onClickCell"></div>

                  <div class="child" id="bottom-left" @click="onClickCell"></div>
                  <div class="child" id="bottom-center" @click="onClickCell"></div>
                  <div class="child" id="bottom-right" @click="onClickCell"></div>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <h5>{{ $t("settings.screenScale") }}</h5>
              <div class="ml-2" style="width: 120px">
                <v-select v-model="selectedScale" :items="items" @change="onChange" dense outlined></v-select>
              </div>
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <!-- 설정 페이지 하단 고정: 사업자 정보 푸터 (모든 탭에서 항상 표시) -->
    <TheFooter class="settings-footer" />
  </div>
</template>

<script>
import { ALL_MODEL_INDEXES } from "@/constants";
import AppConfiguration from "../domain/AppConfiguration";
import SupabaseApi from "@/api/SupabaseApi";
import { supabase } from "@/utils/supabase";
import TheFooter from "@/components/TheFooter.vue";
import { uploadProfileImage } from "@/utils/profileImage";

const allModelMetas = ALL_MODEL_INDEXES.map((modelIndex) => ({ modelIndex }));

export default {
  components: { TheFooter },
  created() {
    // 없으면 기본값을 그냥 설정하자
    const { x = "right", y = "bottom" } = AppConfiguration.get("broadcastScreenPosition") || {};
    AppConfiguration.set("broadcastScreenPosition", { x, y });

    const scale = AppConfiguration.get("broadcastScreenScale") || 1;
    AppConfiguration.set("broadcastScreenScale", scale);

    this.initAccountSetting();
  },
  mounted() {
    this.loadSelectedModelIndex();

    // 초기값 표현
    const { x, y } = AppConfiguration.get("broadcastScreenPosition");
    const targetEl = this.$el.querySelector(`#${y}-${x}`);
    if (targetEl) targetEl.innerHTML = `<div class="dot"></div>`;

    this.selectedScale = AppConfiguration.get("broadcastScreenScale");
  },
  data() {
    return {
      tab: 0,
      accountEmail: "", // 현재 로그인 계정 이메일 (프로필 아래 표시)
      // 계정설정
      nickname: "",
      newPassword: "",
      confirmPassword: "",
      isSavingNickname: false,
      isSavingPassword: false,
      // 프로필 사진
      isShowProfileDialog: false,
      profileTab: 0, // 0: URL 입력 / 1: 업로드(파일 첨부만)
      profileImageUrl: "",
      profileFile: null,
      profileFilePreview: null, // 선택 파일 로컬 미리보기 objectURL
      isSavingProfile: false,
      isShowDialog: false,
      selectedModelIndex: null,
      selectedScale: null,
      modelMetas: allModelMetas,
      items: [
        { text: "100%", value: 1 },
        { text: "120%", value: 1.2 },
        { text: "150%", value: 1.5 },
        { text: "180%", value: 1.8 },
        { text: "200%", value: 2 },
      ],
    };
  },
  computed: {
    // 다이얼로그 미리보기: 업로드 탭은 선택 파일, URL 탭은 입력값, 없으면 현재 저장된 이미지
    profilePreviewUrl() {
      if (this.profileTab === 1 && this.profileFilePreview) return this.profileFilePreview;
      return this.profileImageUrl || this.$store.state.userImageUrl;
    },
    // 저장 가능: URL 탭은 https URL, 업로드 탭은 파일 선택 시
    canSaveProfile() {
      return this.profileTab === 1 ? !!this.profileFile : (this.profileImageUrl || "").startsWith("https://");
    },
  },
  watch: {
    // 선택 파일 → 로컬 미리보기 objectURL (이전 것 해제)
    profileFile(file) {
      if (this.profileFilePreview) URL.revokeObjectURL(this.profileFilePreview);
      this.profileFilePreview = file ? URL.createObjectURL(file) : null;
    },
  },
  methods: {
    // 프로필 사진 — 다이얼로그 열기(현재 이미지로 프리필) / 저장(URL 또는 업로드)
    openProfileDialog() {
      const cur = this.$store.state.userImageUrl || "";
      this.profileImageUrl = cur.startsWith("https://") ? cur : "";
      this.profileFile = null;
      this.profileTab = 0;
      this.isShowProfileDialog = true;
    },
    async onSaveProfileImage() {
      this.isSavingProfile = true;
      try {
        let url;
        if (this.profileTab === 1) {
          // 업로드 탭: 원형 크롭 결과(정사각 PNG) → 리사이즈 + 해시 파일명으로 R2 업로드
          if (!this.profileFile) return;
          const blob = await this.$refs.profileCropper.getBlob();
          url = await uploadProfileImage(blob, "user");
        } else {
          // URL 탭: 외부 https 주소
          url = (this.profileImageUrl || "").trim();
          if (!url.startsWith("https://")) {
            return this.$notify({ type: "warning", title: this.$t("settings.profileUrlInvalid"), duration: 2400 });
          }
        }
        await SupabaseApi.UserAccount.updateImageUrl(url);
        this.$store.commit("__setUserImageUrl", url);
        this.isShowProfileDialog = false;
        this.$notify({ type: "success", title: this.$t("settings.profileSaved"), duration: 2000 });
      } catch (error) {
        console.error(error);
        this.$notify({ type: "error", title: this.$t("settings.profileFailed"), duration: 2400 });
      } finally {
        this.isSavingProfile = false;
      }
    },
    // 계정설정 — 닉네임/비밀번호
    async initAccountSetting() {
      try {
        const {
          data: { user },
        } = await supabase.auth.getUser();
        this.accountEmail = (user && user.email) || "";
        const profile = await SupabaseApi.fetchMyProfile();
        this.nickname = (profile && profile.name) || "";
      } catch (error) {
        console.error(error);
      }
    },
    async onSaveNickname() {
      const name = (this.nickname || "").trim();
      if (!name) return;
      this.isSavingNickname = true;
      try {
        await SupabaseApi.UserAccount.updateNickname(name);
        this.$store.commit("__setUserName", name);
        this.$notify({ type: "success", title: this.$t("settings.nicknameSaved"), duration: 2000 });
      } catch (error) {
        console.error(error);
        this.$notify({ type: "error", title: this.$t("settings.nicknameFailed"), duration: 2400 });
      } finally {
        this.isSavingNickname = false;
      }
    },
    async onSavePassword() {
      const pw = this.newPassword || "";
      if (pw.length < 6) {
        return this.$notify({ type: "warning", title: this.$t("settings.pwTooShort"), duration: 2400 });
      }
      if (pw !== this.confirmPassword) {
        return this.$notify({ type: "warning", title: this.$t("settings.pwMismatch"), duration: 2400 });
      }
      this.isSavingPassword = true;
      try {
        await SupabaseApi.UserAccount.changePassword(pw);
        this.newPassword = "";
        this.confirmPassword = "";
        this.$notify({ type: "success", title: this.$t("settings.pwChanged"), duration: 2000 });
      } catch (error) {
        console.error(error);
        this.$notify({ type: "error", title: this.$t("settings.pwFailed"), duration: 2400 });
      } finally {
        this.isSavingPassword = false;
      }
    },
    onClickCell(e) {
      try {
        if (e.target.id === "") return;

        const id = e.target.id;

        const [y, x] = id.split("-");

        AppConfiguration.set("broadcastScreenPosition", { x, y });
      } catch (error) {
        console.error(error);
      } finally {
        if (e.target.id !== "") {
          const els = this.$el.querySelectorAll(".parent div");
          els.forEach((el) => {
            el.innerHTML = "";
          });

          const targetEl = this.$el.querySelector(`#${e.target.id}`);
          if (targetEl) targetEl.innerHTML = `<div class="dot"></div>`;
        }
      }
    },
    onChange(value) {
      AppConfiguration.set("broadcastScreenScale", value);
    },
    async loadSelectedModelIndex() {
      const modelIndex = await SupabaseApi.PetProfile.fetchModelIndex();
      this.selectedModelIndex = modelIndex;
    },
    async onSelectModel(modelIndex) {
      // update to api
      // update currentModelIndex
      this.selectedModelIndex = modelIndex;
      this.$store.commit("__setCurrentModelIndex", this.selectedModelIndex);
      await SupabaseApi.PetProfile.changeModelIndex(modelIndex);
    },
  },
};
</script>

<style scoped>
/* 푸터를 페이지 하단으로 밀어내기 (page-root는 min-height:100vh) — scoped라 이 페이지에만 적용 */
.page-root {
  display: flex;
  flex-direction: column;
}
/* 내용 영역만 늘어나 푸터를 하단으로 밀어냄. 내용 자체는 위에서 자연 흐름(늘어나지 않음) */
.settings-content {
  flex: 1 0 auto;
}
.settings-footer {
  flex-shrink: 0;
  padding-top: 32px;
}

.parent {
  display: grid;
  grid-template-columns: repeat(3, 24px);
  grid-template-rows: repeat(3, 24px);
}
.child {
  border: 1px solid grey;
  margin-left: -1px;
  margin-top: -1px;

  display: flex;
  justify-content: center;
  align-items: center;
}

>>> .dot {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: red;
}
</style>
